import React from "react";
import './App.css';
import SearchForm from "./component/SearchForm";
import ReactTab from "./component/ReactTab";

export default class App extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      type: '',
      since: '',
      to: '',
      id: '',
      results: [],
      request: ''
    }
  }

  componentDidMount() {
    this.mounted = true;
    // Permet d'afficher tout l'historique de base
    this.query()
  }

  // Fonction qui permet de mettre à jour les states quand un des champs du formulaire est rempli (Temps réel)
  handleChange = (e) => {
    const target = e.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
    //console.log(name + " : " + value)
  }

  // Fonction utilisée quand le bouton "Filtrer" est appuyé
  handleSubmit = () => {
    //console.log(this.state)
    this.query()
  }

  query() {
    if(this.mounted) {
      let url = "https://ws.apidae-tourisme.com/v1/sit/referentiel/get-history?";
      let url_export = "https://ws.apidae-tourisme.com/v1/sit/referentiel/csv?";
      // Si le paramètre type est renseigné
      if (this.state.type) {
        url += "type=" + this.state.type;
        url_export += "type=" + this.state.type;
      }
      // Si le paramètre since est renseigné
      if (this.state.since && this.state.since !== "yyyy-MM-dd") {
        url += "&since=" + this.state.since;
        url_export += "&since=" + this.state.since;
      }
      // Si le paramètre to est renseigné
      if (this.state.to && this.state.to !== "yyyy-MM-dd") {
        url += "&to=" + this.state.to;
        url_export += "&to=" + this.state.to;
      }
      // Si le paramètre id est renseigné
      if (this.state.id) {
        url += "&id=" + this.state.id
        url_export += "&id=" + this.state.id
      }
      // console.log(this.state.request);
      fetch(url)
          .then(response => {
            if (!response.ok) {
              //console.log(response.statusText)
              return
            }
            this.setState({
              request: url_export,
            })
            return response.json()
          })
          .then(data => {
            this.setState({results: data})
          })
    }
  }

  render() {
    //console.log(this.state.request);
    return (
          <div className="hi_ref">
            <SearchForm
              change={this.handleChange}
              submit={this.handleSubmit}
              type={this.state.type}
              id={this.state.id}
              since={this.state.since}
              to={this.state.to}
            />
            <ReactTab
              results={this.state.results}
              request={this.state.request}
            />
          </div>
      );
  }
}
